<template>
 <div class="signature_entry_page">
   
   <router-view v-wechat-title='$route.meta.title'></router-view>
     <div class="flex1 box2">
         <div class="text_1">请签名</div>
        <div class="flex2">
            <div class="flex2 box_1" @click="handelClearEl()">
                <img src="../images/b1.png" alt="" class="tip_imgs">
                <div class="text_2">清除</div>
            </div>

            <div class="flex2 box_1" @click="goBack()">
                <img src="../images/b2.png" alt="" class="tip_imgs">
                <div class="text_2">撤销</div>
            </div>
        </div>
     </div>
    <div id="canvas">
    </div>
    <div @click="handelSaveEl()" class="save_btns">保存</div>
    <div class="mask" v-if="showTip">
        <img src="@/images/success_tip1.png" alt="" class="success_tip_img trans" @click="hideTip">
    </div>
    <img :src="imgsrc" alt="" id="aaaaaa" class="vans_pos">
    <canvas id="finalCanvas" class="vans_pos"></canvas>
  </div>
</template>
<script>
import {Dialog,Toast } from "vant"
import {UpLoadPharName,SignPharmacistName} from "@/utils/api.js"
import {getToken,getCookie,dataURLtoBlob,blobToFile,guid2 } from "@/utils/common.js"
import SHA1 from "sha1"
import axios  from "axios"
let canvas = document.createElement("canvas");
let ctx = canvas.getContext("2d");
console.log(canvas)
console.log(ctx)
export default {
  data() {
    return {
      signObj:{},
        w:0,
        h:0,
        canvasHistory:[],
      linewidth: 5, //线条粗细，选填
      color: "black", //线条颜色，选填
      background: "rgba(255, 255, 255, 0)", //线条背景，选填
      imgsrc: "",
      step:-1,
      canvasWidth:0,
      canvasHeight:0,
      showTip:false,
    };
  },
  mounted() {
document.querySelector(".signature_entry_page").addEventListener('touchmove', function(e) {
    e.preventDefault();
  }, { passive: false });  
    console.log("mounted");
    console.log(this.color);
    this.getCanvas();
  },
  methods: {
      hideTip(){
          this.showTip = false
          sessionStorage.setItem("signImg",JSON.stringify(this.signObj))
          this.$router.go(-1)

      },
      goBack(){
        if (this.step >= 0) {
            this.step--;
            ctx.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
            let canvasPic = new Image();
            canvasPic.src = this.canvasHistory[this.step];
            this.canvasHistory.splice(this.step,1)
            canvasPic.addEventListener('load', () => {
            ctx.drawImage(canvasPic, 0, 0);
            });
        } else {
            Toast("不能再继续撤销了")
        }

      },
    dataURLtoFile(dataurl, filename) {//将base64转换为文件
        var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
    },
    getCanvas() {
    let el = document.getElementById("canvas");
      el.appendChild(canvas);
      canvas.width = el.clientWidth;
    //   this.w= el.clientWidth
    //   this.h = 464
      this.canvasWidth = el.clientWidth
      this.canvasHeight = el.clientWidth*0.66;
      canvas.height = el.clientWidth*0.66;
      
      ctx.fillStyle = this.background; //填充绘图的背景颜色
      ctx.fillRect(0, 0, canvas.width, canvas.height); //绘制“已填色”的矩形
      ctx.strokeStyle = this.color; //笔触的颜色
      ctx.lineCap = "round"; //线条末端线帽的样式
      let linewidth = this.linewidth;
      //开始绘制
      canvas.addEventListener(
        "touchstart",
        function(e) {
          ctx.beginPath();
          ctx.lineWidth = linewidth; //当前线条的宽度，以像素计
          ctx.moveTo(e.changedTouches[0].pageX, e.changedTouches[0].pageY-55);
        }.bind(this),
        false
      );
      //绘制中
      canvas.addEventListener(
        "touchmove",
        function(e) {
          ctx.lineTo(e.changedTouches[0].pageX, e.changedTouches[0].pageY-55);
          ctx.stroke();
        }.bind(this),
        false
      );
      //结束绘制
      canvas.addEventListener(
        "touchend",
        function() {
          ctx.closePath();
          let myCanvas = document.querySelector('canvas');
          this.step++
          this.canvasHistory.push(myCanvas.toDataURL()); // 添加新的绘制到历史记录
          console.log(this.canvasHistory)
        }.bind(this),
        false
      );
    },
    handelColour() {
      this.color = "red";
      this.getCanvas();
    },
    handelThickness() {
      this.linewidth = 5;
      this.getCanvas();
    },
    handelClearEl() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      this.canvasHistory = []
      this.step = -1
    },

  imgToCanvas(img){
    console.log(img)
    var finalCanvas = document.getElementById("finalCanvas");
    var imgsss = document.getElementById("aaaaaa");
    var ctx = finalCanvas.getContext("2d");
    ctx.fillStyle = "rgba(255, 255, 255, 0)"
    var bgImage = new Image();
    bgImage.src = this.imgsrc;
    console.log(bgImage)
    let num= canvas.width/80 //倍数

    finalCanvas.width="80"
    finalCanvas.height=canvas.height/num+""
    // alert(imgsss.width)
    // alert(imgsss.height)
    ctx.drawImage(bgImage,0,0,imgsss.width,imgsss.height*2,0,0,80,canvas.height*6/num);
    // ctx.fillRect(0,0,150,75);
    console.log(finalCanvas.toDataURL())
    this.imgsrc = finalCanvas.toDataURL()
    
  },

    handelSaveEl() {
        Dialog.confirm({
        title: '保存签名',
        message: '确定保存签名吗'
        }).then(() => {
            Toast.loading({
                message: "签名生成中",
                duration: 0
            })
            let imgBase64 = canvas.toDataURL();
            this.imgsrc = imgBase64;
            
            setTimeout(() => {
              this.imgToCanvas(imgBase64,canvas.width)


              let fd = new FormData();
              
              var blob = dataURLtoBlob(imgBase64);
              // var blob = dataURLtoBlob(this.imgsrc);
              var file = blobToFile(blob, "PharName");
              // fd.append("ShopPic", file);
              fd.append("ShopPic", file,file.name+"."+file.type.substring(file.type.lastIndexOf("/")+1));
              this.imgUpload(fd).then(res=>{
                Toast.clear()
                  if(res.data.code==1){
                      this.showTip = true
                      this.signObj = res.data.data
                  }else{
                      Toast(res.data.msg)
                  }
              })


            }, 1000);
            return
        }).catch(() => {
        // on cancel
        });
    },
    imgUpload(fd) {
      return new Promise((resolve, reject) => {
    let params = {
      useType:7,
      update:false,
      timestamp:parseInt(new Date()/1000),
      nonce:guid2()
    }
    var sorted =Object.keys(params).sort().map(item=>{
        return item+"="+params[`${item}`]
    }).join("&")
    console.log(sorted)
    var sign = SHA1(sorted)
    console.log(sign)
    var url = `${process.env.VUE_APP_HOSPITAL}/api/v3/Shop/UploadShopPic?`+sorted+"&sign="+sign.toUpperCase()
    console.log(url)
        axios.post(url, fd).then(res => {
          console.log(res);
          Toast.clear();
        if (res.data.code == 1) {
            resolve(res);
          } else {
            Toast(res.data.msg);
          }
        });
      });
    },
  }
};
</script>
<style  lang="scss" scoped>
.signature_entry_page{
    padding: 0 15px;
    border-top: 5px solid #F7F7F7;
    // padding-top: 15px;
    background-color: #fff;
    .mask{
        position: fixed;
        left: 0;
        top: 0;
        background: rgba(0, 0, 0, .5);
        width: 100%;
        height: 100%;
    }
    .success_tip_img{
        width:295px;
        height:255px;
        background:rgba(255,255,255,1);
        border-radius:5px;
        position: absolute;
       
    }
    #canvas {
    width: 100%;
    height: 98%;
    overflow: hidden;
    position: relative;
    background-color: rgba(248,248,248,1);
    margin-top: 17px;
    }
    #canvas canvas {
    display: block;
    }
    p{
        font-size: 20px;
        margin-bottom: 20px;
    }
    .text_1{
        font-size:16px;
        color:rgba(51,51,51,1);
        
    }
    .text_2{
        font-size:16px;
        color:#807AF4;
        flex: 0 0 auto;
        margin-left: 6px;
    }
    .box_1{
        flex: 0 0 auto;
    }
    .box_1:first-child >.tip_imgs{
        width: 18px;
        height: 16px;
    }
    .box_1:last-child>.tip_imgs{
        width:18px;
        height:16px;
        margin-left: 25px;
    }
    .save_btns{
        width:300px;
        height:42px;
        background:rgba(19,165,188,1);
        border-radius:21px;
        text-align: center;
        line-height: 42px;
        font-size:18px;
        color:rgba(255,255,255,1);
        margin: 0 auto;
        margin-top: 30px;
    }
    .box2{
        margin-top: 15px;
    }
    .vans_pos{
      position: fixed;
      left: 2000px;
    }
}


</style>